// extracted by mini-css-extract-plugin
module.exports = {"prosAndCons":"ProsAndCons_prosAndCons__JQZLG","cons":"ProsAndCons_cons___1qBK","list":"ProsAndCons_list__xJwhx"};